import React from 'react';

import { LinkPreview } from 'types/common';

import { ChatMessageScheduleButtonWithModalOpen } from 'features/chat/components/ChatMessagesScheduling/ScheduleButton';
import { ChatMessageViewScheduledMessagesButton } from 'features/chat/components/ChatMessagesScheduling/ViewScheduledMessagesButton';
import { useChatMessageSchedulingContext } from 'features/chat/context/chatMessageScheduling';

type ScheduledButtonContainerProps = {
  text: string;
  linkPreview?: LinkPreview;
  onSubmit: (
    text: string,
    scheduledFor: string,
    linkPreview?: LinkPreview
  ) => void;
};

export const ScheduleButtonContainer = ({
  text,
  linkPreview,
  onSubmit,
}: ScheduledButtonContainerProps) => {
  const {
    isCreateScheduleMessageButtonVisible,
    isViewScheduledMessagesButtonVisible,
  } = useChatMessageSchedulingContext();

  return (
    <>
      {isCreateScheduleMessageButtonVisible ? (
        <ChatMessageScheduleButtonWithModalOpen
          onSubmit={(scheduledFor) => {
            onSubmit(text, scheduledFor, linkPreview);
          }}
        />
      ) : null}
      {isViewScheduledMessagesButtonVisible ? (
        <ChatMessageViewScheduledMessagesButton />
      ) : null}
    </>
  );
};
